<template>
  <div
    class="mt-2 landing-home"
    :class="{ 'mt-10': $vuetify.breakpoint.xsOnly }"
  >
    <v-alert
      icon="mdi-book-education"
      color="#F39200"
      border="left"
      prominent
      light
      class="mb-15 mt-5"
    >
      Stai cercando soluzioni formative per il PNRR - Formazione del personale
      scolastico per la transizione digitale (DM 66/2023)? Scopri il nostro
      catalogo dedicato!
      <u @click="downloadTrainingCatalog">
        <span
          :style="{
            color: 'black',
            fontWeight: '600',
            cursor: 'pointer',
          }"
          href="https://www.sorint.com/privacy-policy/"
        >
          clicca qui
        </span>
      </u>
    </v-alert>

    <v-row justify="center">
      <v-col cols="12" md="6" order="2" order-md="1">
        <h1
          class="landing-title mb-10"
          :class="{
            'landing-title-mobile': $vuetify.breakpoint.xsOnly,
          }"
          :style="{ textAlign: $vuetify.breakpoint.smAndDown ? 'center' : '' }"
        >
          School Contest Premio
          <span class="colored-hacker">GFMarilli</span>
          <span> 2025</span>
        </h1>

        <h4
          class="landing-paragraph mb-14"
          :style="{
            textAlign: $vuetify.breakpoint.smAndDown ? 'center' : '',
            width: $vuetify.breakpoint.smAndDown ? '100%' : '500px',
          }"
        >
          Sei uno studente o una studentessa del III-IV-V anno superiore e hai
          sviluppato un progetto informatico personale o scolastico? Allora non
          perdere questa grande occasione! I progetti informatici sviluppati
          saranno messi in gara per il conseguimento di prestigiosi
          riconoscimenti! Conquista il Contest e aggiudicati i preziosi trofei
          🏆 <strong>HackersGen</strong>!
          <br />
          <div
            @click="goToProject('/')"
            class="landing-bg-gradient font-karasuma font-weight-bold custom-btn text-center p-4 mt-8"
            :style="{ color: 'black' }"
            elevation="2"
            block
          >
            <span class="body-2 font-weight-bold uppercase"
              >GUARDA IL SITO E ISCRIVITI SUBITO!</span
            >
            <v-icon class="ml-2" size="1.3rem" color="black"
              >mdi-rocket-launch</v-icon
            >
          </div>
        </h4>
        <h3
          class="landing-numbers-title mb-5"
          :style="{ textAlign: $vuetify.breakpoint.smAndDown ? 'center' : '' }"
        >
          I NOSTRI NUMERI
        </h3>
        <numbers-displayer
          :style="{
            center: '',
            margin: $vuetify.breakpoint.smAndDown ? 'auto' : '',
          }"
        />
      </v-col>
      <v-col cols="12" md="6" order="1" order-md="2">
        <PlayerVimeo
          class="!h-80"
          :class="{ 'mt-16': $vuetify.breakpoint.smAndDown }"
          :video-link="'https://player.vimeo.com/video/1072073737?autoplay=1&muted=1&loop=1'"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import numbersDisplayer from "@cmp-landing/NumbersDisplayer.vue";
import followUs from "@cmp-landing/FollowUs.vue";
import Earth from "@cmp-space/Earth.vue";
import {
  pushAuthUrl,
  pushEventUrl,
  pushProjectsUrl,
} from "@/utils/externalRouter";
import { mapGetters } from "vuex";
import matomoTracker from "@mixins/matomoTracker";
import api from "@services/axiosInstance";
import PlayerVimeo from "./PlayerVimeo.vue";

export default {
  name: "LandingHome",
  components: { numbersDisplayer, followUs, Earth, PlayerVimeo },
  mixins: [matomoTracker],
  data() {
    return {};
  },
  computed: {
    ...mapGetters("config", ["pnrr_brochure_url"]),
  },
  methods: {
    goToEvent(route) {
      pushEventUrl(route);
    },
    goToProject(route) {
      pushProjectsUrl(route);
    },
    goToLogin() {
      pushAuthUrl("/sign-in");
    },
    async downloadTrainingCatalog() {
      try {
        const { data } = await api.get(this.pnrr_brochure_url, {
          baseURL: "",
          responseType: "blob",
        });
        const blob = new Blob([data]);
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (e) => {
          const a = document.createElement("a");
          a.href = e.target.result;
          a.download = `Sorint_Catalogo_Corsi_DM66.pdf`;
          a.click();
        };
        this.trackEvent("LandingPage", `ClickOnDownloadTrainingCatalog`);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.landing-title {
  font-family: "outerorbit", "Orbitron";
  font-style: normal;
  font-weight: 500;
  font-size: 52px;
  text-transform: uppercase;
  line-height: 65px;
  color: #f4f5f6;
  max-width: 100%;
}

.landing-title-mobile {
  font-size: 40px;
}

.landing-paragraph {
  width: 500px;
  max-width: 100%;
  font-family: "Karasuma Gothic";
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  color: #98a6ae;
}

.landing-bg-gradient {
  background: linear-gradient(90deg, #f39200 48.33%, #fcee21 84.89%);
}

.landing-numbers-title {
  font-family: "outerorbit", "Orbitron";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  color: #f4f5f6;
}
.colored-hacker {
  background: linear-gradient(90deg, #f39200 48%, #fcee21 78%);
  -webkit-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  -moz-background-clip: text;
}
body {
  background: rgba(10, 10, 10, 1);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
}
.container {
  padding: 50px;
}
.sphere {
  position: relative;
  margin: 0 auto;
  display: block;
  height: 300px;
  width: 300px;
  box-shadow: 0px 0px 20px 0px rgba(190, 190, 255, 1);
  background: #0c096d;
  border-radius: 150px;
  transform: rotate(-23.5deg);
}

.layer {
  position: absolute;
  height: 300px;
  width: 300px;
  border-radius: 150px;
  overflow: hidden;
}

.edge {
  height: 300px;
  width: 300px;
  border-radius: 150px;
  box-shadow: inset 0px 0px 100px 20px rgba(0, 0, 0, 0.4);
}

.darkside {
  box-shadow: inset -60px -10px 80px 0px rgba(0, 0, 0, 0.9);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.land {
  animation: rotate 96s linear infinite;
  background-size: 600px 300px;
  filter: brightness(2);
  background: url("data:image/jpeg;base64,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");
}

.clickable {
  cursor: pointer;
}

.custom-btn {
  border-radius: 12px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  text-align: center;
  border-radius: 12px;
  padding: 10px 7px;
  cursor: pointer;
}

.text-center-n {
  text-align: center;
}

@keyframes rotate {
  from {
    background-position-x: 0px;
  }
  to {
    background-position-x: 600px;
  }
}
</style>
